import { Vue, Options } from 'vue-class-component';
import {
CallingCodeDTO,
  EntrancePlantDetailDTO,
  EntrancePlantStructureCreateDTO,
} from '@/../client-generator/generated-clients/plants';
import plantsClient from '@/core/services/plants';
import CodeRecap from '../../CodeRecap/CodeRecap.vue';

@Options({
  name: 'DialogEntrancePlantCreateStep5',
  components: {
    CodeRecap
  },
  props: {
    plant: {
      required: true,
      type: Object as () => EntrancePlantDetailDTO,
    },
    plantId: {
      type: Number,
      required: false,
    },
    structureCreate: {
      required: false,
      type: Object as () => EntrancePlantStructureCreateDTO,
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    plant: function (newValue) {
      if (newValue) this.initializeData();
    },
  },
  emits: ['is-loading', 'onBack', 'onNext', 'plant-edited'],
  computed: {},
})
export default class DialogEntrancePlantCreateStep5 extends Vue {
  plant!: EntrancePlantDetailDTO;
  plantId!: number;
  recapCode = new CallingCodeDTO();
  
  mounted(): void {
    this.initializeData();
  }

  async initializeData() {
    if (!this.plantId) return;
    this.$emit('is-loading', true);

    try {
      this.recapCode = await plantsClient.callingcoderecap(this.plantId);
    } catch (error) {
      this.$toast.add({
        severity: 'error',
        summary: this.$t('general.operationError'),
        closable: true,
        life: 6000,
      });
    } finally {
      this.$emit('is-loading', false);
    }
  }


  handleBackButton() {
    this.$emit('onBack', 'DialogEntrancePlantCreateStep4');
  }

  async handleNextButton() {
    this.$emit('onNext', 'DialogEntrancePlantCreateStep6');
  }
}
